var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerContainer"},[_c('div',[_vm._v("© Sphem 2015 - "+_vm._s(_vm.actualYear))])])
}
var staticRenderFns = []

export { render, staticRenderFns }